module.exports = __webpack_public_path__ + "img/model2_ug.cafa2649.png";